import AabSelect from './AabSelect.js';
import 'lit';
import '@open-wc/scoped-elements';
import '@popperjs/core';
import '@aab/sc-aab-icon/dist/AabIcon';
import '@aab/sc-aab-status/dist/AabStatus';
import '@aab/sc-aab-input/dist/AabInput';
import '@open-wc/dedupe-mixin';
import '@aab/sc-aab-icon-set';
import '@aab/sc-styles-colors';
import 'lit/directives/class-map.js';
import '@aab/sc-aab-translate';

// This file is protected and will be overwritten by the @aab/cli

customElements.define('aab-select', AabSelect);
